export const loginExceptions = {
    PASSWORD_RESET_REQUIRED: "PasswordResetRequiredException",
    USER_NOT_CONFIRMED: "UserNotConfirmedException",
    USER_NOT_FOUND: "UserNotFoundException",
    CODE_MISMATCH: "CodeMismatchException",
    LIMIT_EXCEEDED: "LimitExceededException",
};

export const localStorageSelectOrgUuid = "selectOrganizationUuid";
